import React from 'react';
import { Button, Flex } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import NewsCard from '../../../components/News/NewsCard';
import { newsData } from '../../../data/newsData';
import styles from '../../../components/News/news.module.css';
import MyText from '../../../components/UI/Text/MyText';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import { clrs } from '../../../constants/colors';

const NewsSection = () => {
  const navigate = useNavigate();

  // Сортируем новости по дате (сначала новые) и показываем только последние 3
  const latestNews = newsData
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  const handleNewsClick = (news) => {
    navigate(`/news/${news.id}`);
  };

  const handleSeeAllClick = () => {
    navigate('/news');
  };

  return (
    <section className={styles.newsSection}>
      <Flex style={{ width: "100%", padding: "0 20px" }} align="center" justify="center">
        <Flex style={{ width: "100%", maxWidth: 1440 }} vertical>
          <div className={styles.sectionHeader}>
            <MyText
              style={{
                fontSize: "2.5rem",
                fontWeight: 900,
                color: clrs.textColor,
                textAlign: "center",
                marginBottom: "40px"
              }}
            >
              <IntlMessage id={'homePage.news.title'}/>
            </MyText>
          </div>

          <div className={styles.newsGrid}>
            {latestNews.map((news) => (
              <NewsCard
                key={news.id}
                news={news}
                onClick={handleNewsClick}
              />
            ))}
          </div>

          <div className={styles.seeAllButton}>
            <Button 
              type="primary" 
              size="large"
              icon={<RightOutlined />}
              iconPosition="end"
              onClick={handleSeeAllClick}
            >
              <IntlMessage id={'homePage.news.seeAll'}/>
            </Button>
          </div>
        </Flex>
      </Flex>
    </section>
  );
};

export default NewsSection; 